// @flow
// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
// import GreedyMenu from 'fg-frontend/components/GreedyMenu';

// COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
// import Webslider from 'fg-frontend/src/components/Webslider';

// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
// import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';

// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
// import SelectDesign from './components/SelectDesign';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
// import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
// import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
// import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
// import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
// import Toggler from './components/Toggler';

// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
// import AlertBox from 'fg-frontend/src/components/AlertBox';

// COMMON: Komponenta pro odpocet
// import Countdown from './components/Countdown';

// COMMON: Komponenta pro rozbaleni dalsich fotografii (TODO PDU: nahradit obecnejsi komponentou ListToggle)
// import ShowMorePhotos from './components/ShowMorePhotos'

// COMMON: Komponenta pro AJAX nacteni SVG spritu
// import AddSvgIconSprite from './components/AddSvgIconSprite';

// COMMON: Všeobecná komponenta pro využití JS na globalní úrovni
// import WebLayout from './components/WebLayout';

// COMMON: Komponenta pro nacteni zakladniho instagram feedu
// import InstagramFeed from './components/InstagramFeed';

// COMMON: Komponenta pro zobrazení galerie
// import PhotoSwipe from "./components/PhotoSwipe";

// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
// import configureEshopComponents from './configureEshopComponents';

export default (props: any) => {
  switch ( props.decorator || props.is ) {
    case 'RadioSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'Slider':
      return import('fg-frontend/components/Slider');
    case 'NumberInput':
      return import('fg-frontend/src/components/NumberInput');
    case 'SimpleCollapse':
      return import('fg-frontend/components/SimpleCollapse');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'ListToggle':
      return import('fg-frontend/components/ListToggle');
    case 'SocialShare':
      return import('fg-frontend/components/SocialShare');
    case 'AnchorsList':
      return import('fg-frontend/src/components/AnchorsList');
    case 'RadioSelectTab':
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'GreedyMenu':
      return import('fg-frontend/components/GreedyMenu');
    case 'ShareUrl':
      return import('fg-frontend/src/components/ShareUrl');
    case 'RedirectToUrl':
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'Form':
      return import('fg-frontend/src/components/Form');
    case 'Typeahead':
      return import('fg-frontend/components/Typeahead');

    case 'WebLayout':
      return import('./components/WebLayout');
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'MenuCollapse':
      return import('./components/MenuCollapse');
    case 'MenuSearch':
      return import('./components/MenuSearch');
    case 'AsideNav':
      return import('./components/AsideNav');
    case 'Gallery':
      return import('./components/gallery/index');
    case 'GalleryGrid':
      return import('./components/galleryGrid/index');
    case 'Carousel':
      return import('./components/carousel/index');
    case 'MyList':
      return import('./components/MyList');
    case 'System':
      return import('./components/system/index');
    case 'MapPointer':
      return import('./components/mapPointer');

    default:
      // const eshopComponent = configureEshopComponents(props);
      // if ( eshopComponent ) {
      // 	return eshopComponent;
      // } else {
      console.log(`Unknown component ${ props.decorator || props.is }`);
      return null;
    // }
  }
};



// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/configureWebComponents.js